import { Toast, type ToastComponent } from '@opallabs/lapidary'
import type { ServiceOption } from '../WeekView/queries/useSystemServices'

const successToastMessage = (selectedServices: ServiceOption[]) => {
  if (selectedServices.length > 2) {
    const remainingLength = selectedServices.length - 2
    return `"${selectedServices[0].name} Post", "${
      selectedServices[1].name
    } Post"
        and ${remainingLength} other ${
          remainingLength > 1 ? 'posts' : 'post'
        } were created.`
  }
  if (selectedServices.length > 1) {
    return `"${selectedServices[0].name} Post" and "${selectedServices[1].name} Post"
        were created.`
  }

  return `"${selectedServices[0].name} Post" was created.`
}

export const ContentCreatedToast: ToastComponent<{
  selectedServices: ServiceOption[]
}> = ({ selectedServices, ...toastProps }) => (
  <Toast
    {...toastProps}
    title="Content Added"
    message={successToastMessage(selectedServices)}
  />
)
